import React, {Component} from 'react';


class FileSignGif extends Component {
    constructor(props) {
        super(props)
        
        this.state = {
            text : ''
        }
    }
    componentDidMount() {
        let texts = ["Initializing Data ...","Verifying Signature ...","Sending Signature to DBQ ...", "Finalizing ..."];
        let index = 0;
        this.setState({text : texts[index]})
                this.interval = setInterval(() => {
                    this.setState({ text: texts[++index] })
                    if (index === (texts.length - 1)) {
                        index = texts.length - 2
                    }
                }, 500);
      }
      componentWillUnmount() {
        clearInterval(this.interval);
      }
    render() {
        return (
            <div className="overlay-msg" >
                <div className="overlay-box">
                    <h1 className='gif-file-msg-heading'>Signing the DBQ</h1>
                    <h6 className="gif-file-msg-status">{this.state.text}</h6>
                    <img src="/imgs/app/vbg-icons/gif/sign.gif" alt="DBQ is being written ..."/>
                </div>
            </div>
        );
    }
}

export default FileSignGif